import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=aea77aa4"
import script from "./MainDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MainDialog.vue?vue&type=style&index=0&id=aea77aa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default})
